




















import {Mixins, Component, Prop} from 'vue-property-decorator';
import MallInfo from '@/components/term/mixins/MallInfo';

@Component
export default class MallTab extends Mixins(MallInfo) {
  @Prop({required: false, default: ''})
  readonly path!: string;

  @Prop({required: false, default: 0, type: Number})
  private left?: number;

  private btnClick(pattern: string) {
    let idx = this.mallNos.indexOf(this.currentMallNo);
    if (pattern === 'prev') {
      if (idx > 0) {
        idx = idx - 1;
      } else {
        idx = this.mallNos.length - 1;
      }
    }
    if (pattern === 'next') {
      if (idx < this.mallNos.length - 1) {
        idx = idx + 1;
      } else {
        idx = 0;
      }
    }

    this.$router.push({
      path: '/terms/tab/introduction',
      query: {mallNo: this.mallNos[idx].toString()}
    });
  }
}
